module.exports = __webpack_public_path__ + "img/startPlay.550507a3.svg";